import { Alert, FileInput, FormField } from '@percent/lemonade'
import type { CoverImageFieldProps } from './cover-image-field.types'

export function CoverImageField({
  value,
  rawValue,
  onChange,
  error,
  topAddon,
  label,
  placeholder,
  acceptedFileFormats,
  uploadFileButtonLabel,
  description,
}: Readonly<CoverImageFieldProps>) {
  return (
    <>
      <FormField
        label={label}
        necessity="required"
        status={error ? 'danger' : 'default'}
        statusMessage={error}
        data-testid="coverImageField"
      >
        <>
          {topAddon}
          <FileInput
            placeholder={placeholder}
            accept={acceptedFileFormats}
            dataTestId="coverImageInput"
            onChange={onChange}
            showPreview
            initialImage={typeof value === 'string' ? value : rawValue}
            fileUploadLabel={uploadFileButtonLabel}
            file={value}
          />
        </>
      </FormField>

      <Alert variant="info">{description}</Alert>
    </>
  )
}
